import { showLoginNeededToast } from 'Components/Generic/BOSToasterUtil';
import { SITE_PAGES } from 'Config';
import AppData from 'Data/AppData';
import { useAuthContext } from 'Data/context/Auth';
import { auth_mode } from 'Data/Enum';
import DataManager from 'Lib/DataManager';
import withRouter from 'Lib/hoc/withRouter';

import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { Navigate } from 'react-router';
import { isUserAuthorized } from 'Util';
import ErrorBoundary from '../ErrorBoundary';

const defaultRequiredAuth = {
  roles: [], // Array of required roles, single string for a user role or an array like ['orgId':'role] for org roles.
  mode: auth_mode.ANY,
};

let DM = new DataManager();

const AuthorizedRoute = ({
  children,
  requiredAuth = defaultRequiredAuth,
  navigate,
  location,
}) => {
  const { isLoggedIn } = useAuthContext();

  useEffect(() => {
    DM.add(
      AppData.registerListener(
        'REQUEST_AUTHORIZATION_DENIED',
        authErrorHandler,
      ),
      AppData,
    );
    DM.add(
      AppData.registerListener('USER_AUTH_ERR', authErrorHandler),
      AppData,
    );

    return () => {
      DM.clear();
    };
  }, []);

  useEffect(() => {
    !isLoggedIn &&
      showLoginNeededToast(() => {
        navigate(SITE_PAGES.LOG_IN.to, { state: { from: location } });
      });
  }, [isLoggedIn]);

  const authErrorHandler = (authErrorPayload) => {
    if (
      authErrorPayload?.message ===
      'User is missing required permission to get this request'
    ) {
      navigate(SITE_PAGES.ACCESS_DENIED.to);
    } else if (
      authErrorPayload?.text === 'Not logged in' ||
      authErrorPayload?.text === 'No session active.' ||
      authErrorPayload?.message === 'Not logged in' ||
      authErrorPayload?.message === 'No session active.'
    ) {
      showLoginNeededToast(() => {
        navigate(SITE_PAGES.LOG_IN.to, { state: { from: location } });
      });
    }
  };

  let allowed = isUserAuthorized(requiredAuth);

  return isLoggedIn ? (
    allowed ? (
      <ErrorBoundary>{children}</ErrorBoundary>
    ) : (
      <Navigate to={SITE_PAGES.ACCESS_DENIED.to} />
    )
  ) : undefined;
};

AuthorizedRoute.propTypes = {
  children: PropTypes.node,
  requiredAuth: PropTypes.shape({
    roles: PropTypes.array,
    mode: PropTypes.string,
  }),
  navigate: PropTypes.func,
  location: PropTypes.object,
};

export default withRouter(AuthorizedRoute);
